import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/leads_/details/$leadId/customer-data')({
    component: Outlet,
});
